export default "/images/vendor/flag-icons/flags/1x1/il.svg?64814d3eb4e199bff1604e9a7cad76ae";